// @flow
import * as React from 'react';
import {Col} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import {Controller} from "react-hook-form";
import {Dropdown} from "primereact/dropdown";

type
Props = {};
export const DropDownFormat = ({control, name, label, options, errors, required}) => {
    return (
            <Form.Group className="mb-3 d-flex flex-column  drop-down-group "
                        controlId="formBasicEdu">
                <Form.Label className="fw-bold pb-1">{label}    
                {required && <span className="mx-1 text-danger">*</span>}</Form.Label>

                <Controller control={control}
                            name={name}
                            render={({field}) => (<Dropdown
                                value={field.value || ""}
                                options={options}
                                onChange={(e) => {

                                    // setBankId(e.value); // Add this line to set the provinceId
                                    field.onChange(e)

                                }}
                                optionValue="value"
                                optionLabel="label"
                                placeholder={label}
                                name={name}
                                className="w-75"
                                filter
                            />)}/>
                {errors && (<div
                    className="text-danger">{errors[name]?.message}</div>)}
            </Form.Group>

       );
};